import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=6e718b42&scoped=true"
import script from "./CategoryEdit.vue?vue&type=script&lang=js"
export * from "./CategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=6e718b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e718b42",
  null
  
)

export default component.exports